import './init-carousel';
import './init-cookie-popup';
import './init-fancybox';
import './init-fontawesome';
import './init-facade-content-show';
import './init-header';
// import './init-lazyload';
import './init-leaflet-map';
import './init-menu';
import './init-pikaday';
import './init-scroll-btn';
import './init-search';
import './init-select2';
import './init-side-nav';
import './init-svg4everybody';
import './init-tooltip';
import './init-validation';

import(/* webpackChunkName: "typeahead" */ './init-typeahead');

if (document.querySelector('.js-fifty-fifty-slider')) {
  import(/* webpackChunkName: "fifty-fifty-slider" */ './init-fifty-fifty-slider');
}
